import { Paragraph1, Paragraph2, SmallText } from 'inpock-ui-react';
import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import { 현금영수증_발행용도 } from '@/apis';
import { Accordion } from '@/components';

import { CashReceiptForm } from '../../../../components/checkout/CashReceiptForm';
import { CashReceiptFormType, FormProps } from '../types';

export interface CashReceiptFormProps extends FormProps<CashReceiptFormType> {
  cashReceiptUsage: 현금영수증_발행용도;
  setCashReceiptUsage: React.Dispatch<React.SetStateAction<현금영수증_발행용도>>;
  cashReceiptTypeSelected: string;
  setCashReceiptTypeSelected: React.Dispatch<React.SetStateAction<string>>;
}

export const CASH_RECEIPT_USAGE: Record<string, string> = {
  '현금영수증 - 미발행': 'null',
  '현금영수증 - 소득공제용 (일반)': 'true',
  '현금영수증 - 지출증빙용': 'false',
};

export function CashReceiptSection({
  isOpen,
  form,
  setForm,
  cashReceiptUsage,
  setCashReceiptUsage,
  cashReceiptTypeSelected,
  setCashReceiptTypeSelected,
}: CashReceiptFormProps) {
  const headerContent = () => {
    const transformedCashReciptUsage = Object.entries(CASH_RECEIPT_USAGE)
      .map(([label, value]) => ({
        label: label.substring(8), // "현금영수증 - " 부분 제거
        value,
      }))
      .filter(({ value }) => {
        return value === String(cashReceiptUsage);
      })[0];

    return (
      <>
        {transformedCashReciptUsage.label}
        {transformedCashReciptUsage.label !== '미발행' && ','} {form.cash_receipt_number}
      </>
    );
  };

  return (
    <>
      <Accordion
        open={isOpen}
        firstRow={<Paragraph1 fontWeight="bold">현금영수증 정보</Paragraph1>}
        secondRow={<Paragraph2 color="gray500">{headerContent()}</Paragraph2>}
        removeBorder
      >
        <section className="mb-30">
          <CashReceiptForm
            form={form}
            setForm={setForm}
            cashReceiptUsage={cashReceiptUsage}
            setCashReceiptUsage={setCashReceiptUsage}
            cashReceiptTypeSelected={cashReceiptTypeSelected}
            setCashReceiptTypeSelected={setCashReceiptTypeSelected}
          />
        </section>
      </Accordion>
      {cashReceiptUsage === null && (
        <CashReceiptGuide>
          <SmallText color="gray600">
            <span className="text-underline">👋 가상계좌/간편결제로 결제하시는 고객님!</span> <br />
            현금영수증 발행여부를 한 번 더 확인해주세요
          </SmallText>
        </CashReceiptGuide>
      )}
    </>
  );
}

const CashReceiptGuide = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: ${colors.gray100};
`;
